import { Component, Input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';

import { ProgressDirective } from '../directive/progress.directive';
import { BarComponent } from '../bar/bar.component';

@Component({
  selector: 'progressbar, [progressbar]',
  template: `
    <div progress [animate]="animate" [max]="max">
      <bar [type]="type" [value]="value">
          <ng-content></ng-content>
      </bar>
    </div>
  `
})
export class ProgressbarComponent {
  @Input() public animate: boolean;
  @Input() public max: number;
  @Input() public type: string;
  @Input() public value: number;
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/progressbar/progressbar.component.ts